import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import '../style.less';

export default class ChildInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    componentDidMount() {

    }

    render() {
        return (
            <div className="aboutMintu">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">关于儿童票的说明</div>
                    <div className="first">
                        （1）儿童座优惠规则以选座页面为准，不参与活动优惠、积分抵扣；<br/>
                        （2）身高未超过1.1米的小孩视为儿童，可以购买儿童坐；<br/>
                        （3）单趟行程仅可购买一张儿童票；<br/>
                        （4）最后排三个座位可选择儿童票；<br/>
                        （5）如不符合儿童标准购买儿童票的乘客，我们将拒绝提供服务；<br/>
                        （6）如未预定儿童座造成的损失由乘车人自行承担。 <br/>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/HelpCenter/ChildInfo/index.js